import { UserDTO } from "./user-dto";

export class User {

    public static readonly DEFAULT = new User(
        '0', 
        'username', 
        'name', 
        'surname', 
        'email', 
        false
    );

    public ID: string;
    public username: string;
    public name: string;
    public surname: string;
    public email: string;
    public emailVerified: boolean;

    constructor(
        ID: string, 
        username: string,
        name: string,
        surname: string,
        email: string,
        emailVerified: boolean
    ) {
        this.ID = ID;
        this.username = username;
        this.name = name;
        this.surname = surname;
        this.email = email;
        this.emailVerified = emailVerified;
    }

    public static createFromDTO(userDTO: UserDTO): User {
        return new User(
            userDTO.ID, 
            userDTO.username,
            userDTO.name,
            userDTO.surname,
            userDTO.email,
            userDTO.emailVerified
        );
    }

}